module.exports = __webpack_public_path__ + "img/dungeontemplate.1ce9b87d.png";